(function () {
  const MAX_DISPLAY = 12;
  const STORAGE_KEY = 'recently_viewed';

  function normalizeRootUrl(root) {
    var r = root == null || root === '' ? '/' : String(root);
    if (!r.endsWith('/')) r += '/';
    return r;
  }

  function buildCardFragmentUrl(root, handle, view, sectionId) {
    var base = normalizeRootUrl(root);
    return (
      base +
      'products/' +
      encodeURIComponent(handle) +
      '?view=' +
      encodeURIComponent(view) +
      '&section_id=' +
      encodeURIComponent(sectionId)
    );
  }

  function initRecentlyViewedSwiper(section) {
    if (!section || typeof window.initAriSwiperCarousels !== 'function') return;
    var root = section.querySelector('[data-ari-swiper-root]');
    if (!root) return;
    var container = document.getElementById('recently-viewed-swiper');
    if (!container) return;
    container.removeAttribute('data-ari-swiper-initialized');
    window.initAriSwiperCarousels(root);
  }

  async function fetchProductCardHtml(root, handle, view, sectionId) {
    var url = buildCardFragmentUrl(root, handle, view, sectionId);
    var res = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    if (!res.ok) return null;
    var text = await res.text();
    return text && text.trim() ? text : null;
  }

  async function initRecentlyViewed() {
    if (
      window.location.pathname !== '/cart' &&
      !window.location.pathname.match(/^\/[a-z]{2}(-[A-Z]{2})?\/cart$/)
    ) {
      return;
    }
    var raw = '';
    try {
      raw = localStorage.getItem(STORAGE_KEY) || '';
    } catch (_) {
      return;
    }
    var list = [];
    try {
      if (raw) list = JSON.parse(raw);
      if (!Array.isArray(list)) list = [];
    } catch (_) {
      return;
    }
    var items = list
      .filter(function (item) {
        return item && item.handle && String(item.handle).trim();
      })
      .slice(0, MAX_DISPLAY);
    if (items.length === 0) return;
    var section = document.getElementById('recently-viewed-section');
    var container = document.getElementById('recently-viewed-swiper');
    if (!section || !container) return;

    var view = section.getAttribute('data-recently-viewed-product-card-view') || 'product_card';
    var sectionId =
      section.getAttribute('data-recently-viewed-product-card-section-id') || 'product-card-ajax';
    var root = section.getAttribute('data-routes-root') || '';

    var handles = items.map(function (item) {
      return String(item.handle).trim();
    });

    var fragments = await Promise.all(
      handles.map(function (handle) {
        return fetchProductCardHtml(root, handle, view, sectionId);
      })
    );

    var html = fragments
      .map(function (fragment) {
        if (!fragment) return '';
        return (
          '<swiper-slide class="ari-new-collection__slide">' + fragment + '</swiper-slide>'
        );
      })
      .filter(Boolean)
      .join('');
    if (!html) return;
    container.innerHTML = html;
    section.style.display = 'block';
    initRecentlyViewedSwiper(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  } else {
    initRecentlyViewed();
  }
})();
